import React from 'react';
import Box from '@ntuctech/devex-tangram/Box';
import ButtonOutlined from '@ntuctech/devex-tangram/Button/ButtonOutlined';
import ButtonText from '@ntuctech/devex-tangram/Button/ButtonText';
import Typography from '@ntuctech/devex-tangram/Typography';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import { hasLinkCard } from '../../services/cards';
import { FLAGS } from '../../services/feature-flag';
import { useUser } from '../../services/profile';
import { useFeatures } from '../DynamicFeatureProvider';
import AddressForm from '../LpApplyCard/AddressForm';
import ApplyCardBenefitList from '../LpApplyCard/ApplyCardBenefitList';
import SimpleModal from '../SimpleModal';
import IllustrateNoRecords from '../Theme/Illustrate-no-records';

import Finish from './Finish';
import LpPhysicalCardsSingle from './LpPhysicalCardsSingle';

const LpPhysicalCardsSC = styled.div`
  .connect-button {
    margin: 0 0.25rem;
    width: 10.875rem;

    @media (max-width: 767px) {
      margin-bottom: 0.75rem;
      width: 9.75rem;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .apply-button {
    :hover {
      background-color: transparent;
    }
  }
`;

const IllustrateNoRecordsChildSc = styled.div`
  max-width: 26.25rem;
  margin: 0 auto;

  .no-record-text {
    color: '#666666';
  }
`;

const LpPhysicalCards = (props) => {
  const { user, userIsReady } = useUser();
  const [openBenefitListModal, setOpenBenefitListModal] = React.useState(false);
  const [openAddressModal, setOpenAddressModal] = React.useState(false);
  const [openFinishModal, setOpenFinishModal] = React.useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [error, setError] = React.useState({ title: '', body: '' });
  const [finishModalMsg, setFinishModalMsg] = React.useState('');

  const { isFlagEnabled } = useFeatures();
  const isDisableRestorationFlowEnabled = isFlagEnabled(FLAGS.DISABLE_LP_RESTORATION);

  const router = useRouter();
  const handleClickConnect = () => {
    router.push('/linkpoints/restore');
  };

  const { records, handleGetPhysicalCards } = props;
  const linkCardExist = hasLinkCard(records);
  // loading
  if (!userIsReady) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <LpPhysicalCardsSC>
      {records && records.length ? (
        records.map((card) => (
          <LpPhysicalCardsSingle
            card={card}
            key={card.cardNumber}
            handleGetPhysicalCards={handleGetPhysicalCards}
            linkCardExist={linkCardExist}
            handleOpenApplyCardBenefitList={setOpenBenefitListModal}
          />
        ))
      ) : (
        <IllustrateNoRecords
          imageLink={
            'https://media.nedigital.sg/linkpass/files/13f8837a-015a-40cd-902f-f90be4678d73/lp-cards-empty.svg'
          }
        >
          <IllustrateNoRecordsChildSc>
            <Typography
              variant="h5"
              data-testid="linkpoints__PhysicalCards--empty_heading"
              className="no-record-text"
            >
              {isDisableRestorationFlowEnabled ? 'No cards yet' : 'There are no cards yet'}
            </Typography>
            <Typography
              variant="body3"
              data-testid="linkpoints__PhysicalCards--empty_instructions"
              className="no-record-text"
            >
              {isDisableRestorationFlowEnabled
                ? 'Link Reward cards linked to your account will appear here.'
                : 'Connect your current Link Rewards card(s) to view them here. This also transfers Linkpoints from your cards to this account.'}
            </Typography>
            {isDisableRestorationFlowEnabled ? (
              <Box mt={3} className="button-container">
                <ButtonOutlined
                  data-testid="linkpoints__apply_plus_card"
                  className="connect-button"
                  onClick={() => setOpenBenefitListModal(true)}
                >
                  Apply Link card
                </ButtonOutlined>
              </Box>
            ) : (
              <Box mt={3} className="button-container">
                <ButtonOutlined
                  data-testid="linkpoints__connect_old_plus_card"
                  className="connect-button"
                  onClick={handleClickConnect}
                >
                  Connect
                </ButtonOutlined>
                <ButtonText
                  data-testid="linkpoints__apply_plus_card"
                  className="apply-button"
                  onClick={() => setOpenBenefitListModal(true)}
                >
                  Apply a free Link card?
                </ButtonText>
              </Box>
            )}
          </IllustrateNoRecordsChildSc>
        </IllustrateNoRecords>
      )}
      {openBenefitListModal && (
        <ApplyCardBenefitList
          openBenefitListModal={openBenefitListModal}
          handleOpenApplyCardBenefitList={setOpenBenefitListModal}
          handleOpenAddressForm={setOpenAddressModal}
        />
      )}
      {openAddressModal && (
        <AddressForm
          nameOnCard={user.name}
          openAddressModal={openAddressModal}
          handleOpenAddressForm={setOpenAddressModal}
          handleOpenFinish={setOpenFinishModal}
          initialFormData={user.residential_address}
          handleOpenError={setShowErrorModal}
          setError={setError}
          setFinishModalMsg={setFinishModalMsg}
        />
      )}
      {openFinishModal && (
        <Finish
          openFinishModal={openFinishModal}
          handleOpenFinishModal={setOpenFinishModal}
          handleGetPhysicalCards={handleGetPhysicalCards}
          finishModalMsg={finishModalMsg}
        />
      )}
      {showErrorModal && (
        <SimpleModal
          open={showErrorModal}
          title={error.title}
          body={error.body}
          ctaAction={() => setShowErrorModal(false)}
          ctaText="OK"
          testId="ReplaceCardError"
        />
      )}
    </LpPhysicalCardsSC>
  );
};

export default LpPhysicalCards;
